import { Grid, styled } from "@mui/material"

export const LayoutGrid = styled(Grid)(({ theme }) => ({
	paddingTop: theme.spacing(3),
	paddingLeft: theme.spacing(3),
}))
